import { $LOADER, $PAGE } from "~/util/Loaders";
import { logPageView } from "~/util/stats";

$PAGE({
  path: "payments/success",
  loader: $LOADER?.(async (cx) => {
    // Log
    logPageView(cx);
    //
    return { authUser: cx.req.sess?.user };
  }),
  render: () => {
    return (
      <div
        className="content"
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          paddingTop: 20,
        }}
      >
        Success
      </div>
    );
  },
});

$PAGE({
  path: "payments/fail",
  loader: $LOADER?.(async () => null),
  render: () => {
    return (
      <div
        className="content"
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          paddingTop: 20,
        }}
      >
        Fail
      </div>
    );
  },
});

$PAGE({
  path: "payments/status",
  loader: $LOADER?.(async () => null),
  render: () => {
    return (
      <div
        className="content"
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          paddingTop: 20,
        }}
      >
        Status
      </div>
    );
  },
});
